import { AccessTimeFilled, Cached, Check, Close, Drafts, Edit, FactCheck, HomeWork, Input, List, LockClock, PunchClock, Refresh, Settings, Task, TimeToLeave, Timelapse, Timeline, Timer, Work, WorkHistory } from '@mui/icons-material';
import { Fab, Step, StepConnector, StepLabel, Stepper, stepConnectorClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { variables } from '../../styles/abstract/variables';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: variables.primary,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: variables.primary,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#777',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: '#777',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: "#fff",
    zIndex: 1,
    fontSize: 28,
  },
  '& .QontoStepIcon-activeIcon': {
    color: "#fff",
    zIndex: 1,
    fontSize: 28,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: '#784af4',
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  const getIcon = () => {
    if(active && (props.status == 'Draft')) return <Fab size="small" color="secondary"><Edit className="QontoStepIcon-activeIcon" /></Fab>;
    if(active && (props.status == 'In Progress')) return <Fab size="small" color='warning'><FactCheck className="QontoStepIcon-activeIcon" /></Fab>;
    if(active && (props.status == 'Rejected')) return <Fab size="small" color='error'><Close className="QontoStepIcon-activeIcon" /></Fab>;
    if(completed) return <Fab size="small" color='primary'><Check className="QontoStepIcon-completedIcon" /></Fab>;

    return <div className="QontoStepIcon-circle" />;
  }

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      
      {getIcon()}
    </QontoStepIconRoot>
  );
}

function CarbonStepper({step, status, applicability}) {
  let stepFinal = step;

  if(applicability === 'Draft' || applicability === 'In Progress' || applicability === 'Rejected') {
    stepFinal = 1;
  } else if(status.monitoring === 'Draft' || status.monitoring === 'In Progress' || status.monitoring === 'Rejected') {
    stepFinal = 2;
  } else {
    stepFinal = 3;
  }


  return (
    <Stepper activeStep={stepFinal} alternativeLabel connector={<QontoConnector />}>
      <Step active={stepFinal === 1}>
        <StepLabel StepIconComponent={(props) => <QontoStepIcon {...props} status={applicability} />}>Applicability</StepLabel>
      </Step>
      <Step active={stepFinal === 2}>
        <StepLabel StepIconComponent={(props) => <QontoStepIcon {...props} status={status.monitoring} />}>Reporting</StepLabel>
      </Step>

      <Step active={stepFinal === 3}>
        <StepLabel StepIconComponent={(props) => <QontoStepIcon {...props} status={status.verification} />}>Verification</StepLabel>
      </Step>

    </Stepper>
  )
}

export default CarbonStepper;